var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalAlignRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(-90)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.79 10H9V1C9 0.45 8.55 0 8 0C7.45 0 7 0.45 7 1V10H5.21C4.76 10 4.54 10.54 4.86 10.85L7.65 13.64C7.85 13.84 8.16 13.84 8.36 13.64L11.15 10.85C11.46 10.54 11.24 10 10.79 10ZM0 17C0 17.55 0.45 18 1 18H15C15.55 18 16 17.55 16 17C16 16.45 15.55 16 15 16H1C0.45 16 0 16.45 0 17Z",
    fill: "#303f47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalAlignRight);
export default __webpack_public_path__ + "static/media/vertical_align_right.6f0a77a74c0e10e1cf57c5fd47d81d54.svg";
export { ForwardRef as ReactComponent };